import MUIDataTable from "mui-datatables";
import Datatable from "../Comp/Table/Datatable";
import { Button, ButtonGroup, Tooltip, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { Popconfirm } from "antd";
import { useEffect, useState } from "react";
// import { axiosPrivate } from "../api/axios/axios";
import { toast } from "react-toastify";
import useStore from "../Hooks/useStore";
import LineChart from "../Comp/Form/lineChart";
import { Image } from "antd";
import AppConstants from "../AppConstrains/AppConstrains";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import { Chip } from "@mui/material";

const TOGGLE_DEAL_STATUS_URL = "/api/deals/toggledealstatus";

// const options = {
//   filterType: "checkbox",
// };

const View = () => {
  const axiosPrivate = useAxiosPrivate();
  const [tableData, setTableData] = useState([]);
  // console.log(tableData, "tableData");
  const FETCH_TABLE_URL = "/api/deals/fetchtable";
  const [loading, setLoading] = useState(true);
  const { fetchAgain, setFetchAgain } = useStore();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  // const [dealTypes, setDealTypes] = useState([]);

  // useEffect(() => {
  //   const fetchTypes = async () => {
  //     try {
  //       const res = await axiosPrivate.get("/api/deals/gettypemaster"); // Your API route
  //       setDealTypes(res.data.data || []);
  //     } catch (err) {
  //       console.error("Failed to fetch deal types");
  //     }
  //   };

  //   fetchTypes();
  // }, []);
  const columns = [
    {
      name: "_id",
      label: "Action",
      options: {
        customBodyRender: (id) => {
          const fullRowData = tableData.find((data) => data._id === id);
          // console.log(fullRowData, "fullRowData");

          // let data = allStoresData.filter((row) => row.store_id === id)[0];
          let tbd_deal_type = fullRowData?.tbd_deal_type || 2;

          return (
            <ButtonGroup orientation="vertical" variant="text" color="success">
              <NavLink
                to={
                  tbd_deal_type === 2 || tbd_deal_type === 1
                    ? "/createdeal"
                    : "/createmessage"
                }
                state={{ fullRowData, tbd_deal_type }}
              >
                <Button color="success">
                  <strong>Edit</strong>
                </Button>
              </NavLink>
              {/* <Popconfirm
                                placement="right"
                                title="Delete Store"
                                description="Do you really want to delete the store?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => console.log(id)}
                            >
                                <Button color="error">
                                    <strong>Delete</strong>
                                </Button>
                            </Popconfirm> */}
            </ButtonGroup>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "active",
      label: "Status",
      options: {
        customBodyRender: (active, tableMeta) => {
          var data = {};
          data._id = tableMeta.rowData[0];
          data.active = active ? false : true;
          if (active)
            return (
              <Popconfirm
                placement="topRight"
                title="Deactivate Store"
                description="Do you really want to deactivate the store?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleStatus(data)}
              >
                <Button color="error" size="small" variant="outlined">
                  <b>Deactivate</b>
                </Button>
              </Popconfirm>
            );
          else
            return (
              <Popconfirm
                placement="topRight"
                title="Activate Store"
                description="Do you really want to activate the store?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleStatus(data)}
              >
                <Button color="success" size="small" variant="outlined">
                  <b>Activate</b>
                </Button>
              </Popconfirm>
            );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "tbd_deal_type",
      label: "Deal Type",
      options: {
        customBodyRender: (value) => {
          let chipProps = {
            size: "small",
            variant: "outlined",
            label: "",
            style: {},
          };

          // You can store color mapping separately
          const colorMap = {
            1: { label: "AI Deal", color: "purple" },
            2: { label: "Manual Deal", color: "orange" },
            3: { label: "Custom Message", color: "blue" },
          };

          if (colorMap[value]) {
            chipProps.label = colorMap[value].label;
            chipProps.style = {
              color: colorMap[value].color,
              borderColor: colorMap[value].color,
            };
          } else {
            chipProps.label = "Unknown";
            chipProps.style = { color: "gray", borderColor: "gray" };
          }

          return <Chip {...chipProps} />;
        },
        filter: true,
        sort: true,
      },
    },

    {
      name: "pid",
      label: "Pid",
      options: {
        customBodyRender: (value) => {
          return (
            <div
              style={{
                width: "auto",
                textAlign: "center",
              }}
            >
              {value}
            </div>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "sid",
      label: "Sid",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <div
              style={{
                // whiteSpace: "nowrap",
                // overflow: "hidden",
                // textOverflow: "ellipsis",
                width: "auto",
              }}
            >
              {Array.isArray(value) ? value.join(", ") : value}
            </div>
          );
        },
      },
    },
    {
      name: "title",
      label: "Title",
      options: {
        customBodyRender: (title) => {
          // console.log(title, "title");

          return (
            <Tooltip title={title} placement="top" arrow>
              <Typography
                // className=" line-clamp-2 w-[200px]"
                sx={{
                  width: "200px",
                  lineClamp: "2",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {title}
              </Typography>
            </Tooltip>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "mrp",
      label: "MRP",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "latestPrice",
      label: "Latest Price",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "imgurl",
      label: "Image",
      options: {
        customBodyRender: (link) => {
          return (
            <div
              // className="size-[40px] rounded overflow-hidden duration-150"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "4px",
                overflow: "hidden",
                transitionDuration: "0.150s",
              }}
            >
              <Image src={link} />
            </div>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "inStock",
      label: "In Stock",
      options: {
        customBodyRender: (inStock, tableMeta) => {
          console.log(inStock, "inStock");
          return (
            <div style={{ width: "70px", textAlign: "center" }}>
              {inStock == false ? 0 : inStock}
            </div>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "aff_url",
      label: "Affiliate Link",
      options: {
        customBodyRender: (link) => {
          // console.log(link, "link");
          return (
            <a href={link} target="_blank" rel="noreferrer">
              <div
                style={{
                  lineClamp: "2",
                  width: "200px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "2",
                  WebkitBoxOrient: "vertical",
                  textAlign: "center",
                }}
                className=""
              >
                {link}
              </div>
            </a>
          );
        },
        filter: true,
        sort: true,
      },
    },

    {
      name: "deal_type",
      label: "Deal Type",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "isExpired",
      label: "IsExpired",
      options: {
        customBodyRender: (value) => {
          return (
            <div
              style={{
                // whiteSpace: "nowrap",
                // overflow: "hidden",
                // textOverflow: "ellipsis",
                width: "auto",
              }}
            >
              {value}
            </div>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "priority",
      label: "priority",
      options: {
        filter: true,
        sort: true,
      },
    },

    {
      name: "brand",
      label: "Brand",
      options: {
        customBodyRender: (brand) => {
          return (
            <div style={{ width: "auto", textAlign: "center" }}>{brand}</div>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "category",
      label: "Category",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <div
              style={{
                width: "auto",
              }}
            >
              {Array.isArray(value) ? value.join(", ") : value}
            </div>
          );
        },
      },
    },
    {
      name: "sub_category",
      label: "Sub Category",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "isSent_app",
      label: "Is Sentapp",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "is_NotificationSent",
      label: "Is Notification Sent",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "isSent_telegram",
      label: "Is Sent Telegram ",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "text",
      label: "Custom Text",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "inserted_at",
      label: "Inserted At",
      options: {
        customBodyRender: (isoDate) => {
          // console.log(link, "link");
          const date = new Date(isoDate);
          return (
            <div style={{ width: "115px" }}>
              {date.toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}
            </div>
          );
        },
        filter: true,
        sort: true,
      },
    },
    {
      name: "updated_at",
      label: "Updated At",
      options: {
        customBodyRender: (isoDate) => {
          // console.log(link, "link");
          const date = new Date(isoDate);
          return (
            <div style={{ width: "115px" }}>
              {date.toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                hour12: true,
              })}
            </div>
          );
        },
        filter: true,
        sort: true,
      },
    },
  ];

  const handleStatus = async (data) => {
    try {
      const response = await axiosPrivate.post(TOGGLE_DEAL_STATUS_URL, {
        _id: data._id,
        active: data.active,
      });

      toast.success(response.data.message);
      setFetchAgain((prev) => !prev);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    }
  };
  const [dealType, setDealType] = useState(0);
  const handleDealTypeChange = (e) => {
    const value = e.target.value;
    setDealType(value);
    // onDealTypeChange?.(value);
  };
  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async (currentPage, currentRowsPerPage) => {
      setLoading(true);
      try {
        const response = await axiosPrivate.post(
          FETCH_TABLE_URL,
          {
            page: currentPage + 1,
            limit: currentRowsPerPage,
            searchTerm: searchTerm,
            deal_type_filter: dealType,
          },
          { signal: controller.signal }
        );
        setTableData(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } catch (error) {
        console.log(error.message);
        toast(error?.response?.data.error);
      } finally {
        setLoading(false);
      }
    };
    fetchData(page, rowsPerPage);

    return () => {
      controller.abort();
    };
  }, [fetchAgain, page, rowsPerPage, dealType]);

  // console.log(page, "page");
  // console.log(rowsPerPage, "rowsPerPage");
  return (
    <div style={{ width: "100%" }}>
      <Datatable
        name="Store Data"
        columns={columns}
        data={tableData}
        totalCount={totalCount}
        setPage={setPage}
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        loading={loading}
        setSearchTerm={setSearchTerm}
        handleDealTypeChange={handleDealTypeChange}
        dealType={dealType}
        setDealType={setDealType}
        searchPlaceholder="Search by Title or PID"
      />
    </div>
  );
};
export default View;
